import {
  Fragment,
  SyntheticEvent,
  useCallback,
  useEffect,
  useState,
} from "react"
import { Block, useStyletron } from "@mezo-org/mezo-clay"
import { useField } from "formik"

import { StakingLockDurationType } from "#/shared/types"
import { StepperModalButton } from "#/ui/Modal"

import { FieldLockDuration } from "../fields"

type LockDurationMenuProps = {
  isOpen: boolean
  fieldName: string
  onClose: () => void
  stakeAmount: bigint
}

export default function LockDurationMenu({
  isOpen,
  fieldName,
  onClose,
  stakeAmount,
}: LockDurationMenuProps) {
  const [css, theme] = useStyletron()
  const [, meta, helpers] = useField<StakingLockDurationType>(fieldName)

  const [lockDuration, setLockDuration] = useState<StakingLockDurationType>(
    meta.value,
  )

  const handelSaveChanges = useCallback(
    (event: SyntheticEvent<HTMLButtonElement>) => {
      event.preventDefault()

      helpers.setValue(lockDuration)
      onClose()
    },
    [helpers, lockDuration, onClose],
  )

  useEffect(() => {
    if (!isOpen) setLockDuration(meta.value)
  }, [isOpen, meta.value])

  return (
    <>
      <Block
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: theme.sizing.scale800,
          padding: `0 ${theme.sizing.scale800}`,
        })}
      >
        <FieldLockDuration
          fieldName={fieldName}
          value={lockDuration}
          setValue={setLockDuration}
          stakeAmount={stakeAmount}
        />
      </Block>
      <Block
        className={css({
          position: "absolute",
          left: 0,
          bottom: 0,
          padding: theme.sizing.scale800,
          backgroundColor: theme.colors.contentInversePrimary,
          width: "100%",
          boxShadow: `0px ${theme.sizing.scale100} ${theme.sizing.scale600} 0px rgba(0, 0, 0, 0.12)`,
        })}
      >
        <StepperModalButton onClick={handelSaveChanges}>
          Confirm changes
        </StepperModalButton>
      </Block>
    </>
  )
}
